module.exports = "<div #template></div>\n<ez-loader></ez-loader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/landing/landing.component.html
// module id = 531
// module chunks = 0